export const optInCampaignGroups = {
  // Business logic
  Lost: [
    'Lost3Months',
    'OTALost3Months',
    'Lost6Months',
    'OTALost6Months',
    'Lost9Months',
    'OTALost9Months',
    'Lost12Months',
    'OTALost12Months',
    'Lost15Months',
    'OTALost15Months',
    'Lost15MonthsPlus',
    'OTALost15MonthsPlus'
  ],
  'In property': [
    'ServiceStartForPrimaryGuest',
    'ServiceStartDayBefore',
    'ServiceStartForSecondaryGuest'
  ],
  'Just booked': ['JustBooked', 'OTAJustBooked'],
  'After visit': ['AfterLastVisit', 'OTAAfterVisit'],
  Review: ['CheckedOutReview', 'OTACheckedOutReview']
}

export function getCampaignNameFromCategory(category) {
  if (category.includes('ConsentRequest')) {
    const baseCampaignCategory = category.replace('ConsentRequest', '')

    return `${campaignNamesForCustomer[baseCampaignCategory]} consent request`
  }

  if (category.includes('OTA')) {
    const baseCampaignCategory = category.replace('OTA', '')

    return `${campaignNamesForCustomer[baseCampaignCategory]} OTA`
  }

  return campaignNamesForCustomer?.[category] || category
}

export function getMainCampaignNameFromCategory(category) {
  if (category.includes('ConsentRequest')) {
    return campaignNamesForCustomer[category.replace('ConsentRequest', '')]
  }

  if (category.includes('OTA')) {
    return campaignNamesForCustomer[category.replace('OTA', '')]
  }

  if (category.includes('ReviewReminder')) {
    return campaignNamesForCustomer['ReviewReminder']
  }

  return campaignNamesForCustomer?.[category] || category
}

const campaignNamesForCustomer = {
  DemoCustomerNextDay: 'Demo upload',
  AfterLastVisit: 'After last visit',
  AfterVisit: 'After visit',
  DemoCustomerImmediate: 'Demo upload immediate',
  DemoCustomerNextWeek: 'Demo upload next week',
  RepeatCustomerReturningSoon: 'Repeat guest',
  Lost3Months: 'Lost 3 months',
  Lost6Months: 'Lost 6 months',
  Lost9Months: 'Lost 9 months',
  Lost12Months: 'Lost 12 months',
  Lost15Months: 'Lost 15 months',
  Lost15MonthsPlus: 'Lost 15 months plus',
  Cancelled: 'Cancelled',
  NoShow: 'No show',
  Birthday: 'Birthday',
  Anniversary: 'Anniversary',
  BookingUpdated: 'Booking updated',
  Holiday: 'Holiday',
  CheckedOutReview: 'Review',
  CardAbandonmentOptedIn: 'Opt-in',
  OptInRequest: 'Opt-in',
  ServiceStartDayBefore: 'Day before check-in',
  ServiceStartForPrimaryGuest: 'During check-in',
  ServiceStartForSecondaryGuest: 'Additional guest check-in',
  ServiceRestart: 'Restart messaging',
  JustBooked: 'Just booked',
  OTAJustBooked: 'OTA Just booked',
  OTAAfterVisit: 'OTA After visit',
  ReviewReminder: 'Review Reminder',
  AI: 'AI',
  AlreadySubscribed: 'Already subscribed',
  SalesAgentVirtual: 'Sales agent virtual',
  DirectAccess: 'Direct access',
  Custom: 'Drip campaigns & Announcements'
}

export const campaignsDescriptions = {
  AfterLastVisit: '15 days – 3 months since last visit',
  RepeatCustomerReturningSoon: 'Guests who are staying more frequently',
  Cancelled: 'Guests who cancel their booking',
  NoShow: 'Guests who didn’t show up for stay',
  CheckedOutReview: 'After Guests stay review request sent',
  Birthday: 'Sent during birthday month',
  Anniversary: 'Sent during anniversary month',
  Holiday: 'Event or Holiday coming up',
  Lost3Months: "3 months since guest's last stay",
  Lost6Months: "6 months since guest's last stay",
  Lost9Months: "9 months since guest's last stay",
  Lost12Months: "12 months since guest's last stay",
  Lost15Months: "15 months since guest's last stay",
  Lost15MonthsPlus: 'More than 15 months since last stay',
  AI: 'Fully Automated messages by SwayPay',
  OTAJustBooked: 'When OTA guest booking confirmation',
  OTAAfterVisit: 'After stay messaging to convert OTA Guests',
  ServiceStartDayBefore: 'Stay reminder for booked guest',
  ServiceStartForSecondaryGuest: 'Secondary guest welcome message',
  ServiceStartForPrimaryGuest: 'Welcome message after check-in',
  ServiceRestart: 'If messaging stopped this is the restart'
}

export const campaignNamesForInternalAdmin = {
  ...campaignNamesForCustomer
}

export const excludedCategories = [
  'CardAbandonmentOptedIn',
  'OptInRequest',
  'ServiceStartForSecondaryGuest',
  'ServiceRestart',
  'DirectAccess',
  'ReviewReminder1',
  'ReviewReminder2',
  'Anniversary',
  'Holiday',
  'Birthday',
  'WidgetNotBookedFollowUp1',
  'WidgetNotBookedFollowUp2',
  'CardAbandonmentNotBookedFollowUp1',
  'CardAbandonmentNotBookedFollowUp2',
  '180',
  '181'
]

export default campaignNamesForCustomer
